import type { ClientContext } from "@common/types/agent-chat-request";
import { readOfficeHost } from "./office-host";

export function buildClientContext(): ClientContext {
  return {
    user_view: {
      user_channel: "word_addin",
      user_page: "chat",
      open_widgets: [],
    },
    office_host: readOfficeHost(),
  };
}
